import React from "react";
import resumeFile from "../assets/documents/resume.pdf";

const Resume = ({ isMobile }) => {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center gap-1">
      <button
        onClick={() => {
          window.open(resumeFile, "_blank");
        }}
        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
      >
        Download Resume
      </button>

      {!isMobile && (
        <div className="w-full h-[85vh] md:h-[90vh] border border-gray-300 rounded-lg overflow-hidden shadow-lg mt-4">
          <object
            data={`${resumeFile}#toolbar=1`}
            type="application/pdf"
            className="w-full h-full"
            title="Resume"
          >
            <p>
              It appears your browser doesn't support embedded PDFs.
              <a href={resumeFile} target="_blank" rel="noopener noreferrer">
                Click here to view the PDF directly
              </a>
            </p>
          </object>
        </div>
      )}

      {isMobile && (
        <div className="text-center mt-8 text-gray-600">
          <p className="mb-2">
            Click the button above to view or download the resume.
          </p>
          <p>For better viewing experience, please use a desktop device.</p>
        </div>
      )}
    </div>
  );
};

export default Resume;
